import React, { useEffect, useState } from 'react';
import { ImCancelCircle } from 'react-icons/im';
import Modal from 'react-modal';
import MrCreateFormComponent from './MrCreateFormComponent';

function MrCreateModal(
  { 
    isOpen, 
    onClose,
    id,
    ActionURL,
    redirectURL,
    setModalOpen,
    detailsData,
    fetchDetailsData,
}) 
  {

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Purchased Details Modal"
      className="modal"
      overlayClassName="overlay"
    >
      <div className='mb-2 w-[360px] md:w-[600px] lg:w-[600px] overflow-y-auto h-[350px]'>
        <div className='modal-title flex justify-between bg-[#fff] text-[#EB5757] text-[18px] px-3 py-2 rounded-[5px] mb-10 shadow fixed top-0 left-0 right-0 z-50'>
          <h1 className='font-semibold uppercase'>MR Create Form</h1>
          <button className='text-[#000]' onClick={onClose}><ImCancelCircle /></button>
        </div>

          <div>
              <MrCreateFormComponent 
                  id={id}
                  ActionURL={ActionURL}
                  redirectURL={redirectURL}
                  setModalOpen={setModalOpen}
                  detailsData={detailsData}
                  fetchDetailsData={fetchDetailsData}
              />
          </div>
      </div>
    </Modal>
  );
}

export default MrCreateModal;